// extracted by mini-css-extract-plugin
export var bottom = "styles-module--bottom--avO1O";
export var c = "styles-module--c--KNFgU";
export var links = "styles-module--links--PkqkH";
export var logo = "styles-module--logo--vm1Bk";
export var top = "styles-module--top--eTjLM";
export var w = "styles-module--w--H1HBA";